import NotificationProduced from '../../application/core/events/NotificationProduced';
import * as uniqid from 'uniqid';
import State from '../../application/core/State';
import Event from '../../application/core/Event';
import Notification from '../../application/core/Notification';
import containsAtLeastOneOrder from './containsAtLeastOneNotSavedOrder';
import OrderDraftSaveRequested from '../../application/order/events/OrderDraftSaveRequested';

export default (state: State, event: OrderDraftSaveRequested): Event[] =>
    containsAtLeastOneOrder(state.order.order!)
        ? [event]
        : [
              new NotificationProduced(
                  new Notification(uniqid(), {
                      message: 'Please, provide/update at least one quantity before you choose to save draft',
                      hasButton: true
                  })
              )
          ];



// WEBPACK FOOTER //
// ./src/domain/estimations/validateSavingOrderDraft.ts